/* ============================================================
   vl-base.js — VELDRA runtime (framework-free)
   Echter AJAX-Cart-Drawer (/cart/add.js, /cart.js, /cart/change.js),
   Mobile-Nav, Header-Shrink, FAQ, Countdown, Reveal, PDP-Varianten/
   Menge/Galerie. Guards + re-init auf shopify:section:load.
   ============================================================ */
(function () {
  'use strict';

  function money(cents) { return (cents / 100).toFixed(2).replace('.', ',') + '€'; }
  var FREE = 5900; // kostenloser Versand ab 59€ (Cent)

  /* ---------- AJAX Cart ---------- */
  function refreshCart(open) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); if (open) openCart(); });
  }
  function renderCart(cart) {
    var count = document.getElementById('vlCartCount');
    if (count) { count.textContent = cart.item_count; count.style.display = cart.item_count ? 'flex' : 'none'; }
    var body = document.getElementById('vlDrawerBody');
    var foot = document.getElementById('vlDrawerFoot');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="vl-cart-empty"><svg viewBox="0 0 24 24"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg><p>Dein Warenkorb ist noch leer.<br>Zeit, dich auszurüsten.</p></div>';
      if (foot) foot.style.display = 'none';
      return;
    }
    if (foot) foot.style.display = 'block';
    body.innerHTML = cart.items.map(function (i) {
      var img = i.image ? '<img src="' + i.image.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2') + '" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:4px">' : '';
      return '<div class="vl-cart-item"><div class="vl-cart-thumb">' + img + '</div>' +
        '<div class="vl-cart-info"><h4>' + i.product_title + '</h4>' +
        '<div class="vl-ci-price">' + money(i.final_price) + '</div>' +
        '<div class="vl-qty"><button data-vl-dec="' + i.key + '">–</button><span>' + i.quantity + '</span><button data-vl-inc="' + i.key + '">+</button>' +
        '<a class="vl-ci-remove" data-vl-rem="' + i.key + '">Entfernen</a></div></div></div>';
    }).join('');
    var totalEl = document.getElementById('vlCartTotal'); if (totalEl) totalEl.textContent = money(cart.total_price);
    var shipMsg = document.getElementById('vlShipMsg'), shipLeft = document.getElementById('vlShipLeft');
    if (shipMsg) {
      var left = FREE - cart.total_price;
      if (left > 0) { shipMsg.style.display = 'flex'; if (shipLeft) shipLeft.textContent = money(left); }
      else { shipMsg.innerHTML = '<svg viewBox="0 0 24 24" style="stroke:var(--vl-moss)"><path d="M5 13l4 4L19 7"/></svg><span>Glückwunsch — du erhältst <b>kostenlosen Versand!</b></span>'; shipMsg.style.display = 'flex'; }
    }
  }
  function addToCart(variantId, qty) {
    if (!variantId) return;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: variantId, quantity: qty || 1 }) })
      .then(function () { refreshCart(true); });
  }
  function changeCart(key, qty) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart);
  }
  function openCart() { var o = document.getElementById('vlOverlay'), d = document.getElementById('vlDrawer'); if (o) o.classList.add('vl-on'); if (d) d.classList.add('vl-on'); document.body.style.overflow = 'hidden'; }
  function closeCart() { var o = document.getElementById('vlOverlay'), d = document.getElementById('vlDrawer'); if (o) o.classList.remove('vl-on'); if (d) d.classList.remove('vl-on'); document.body.style.overflow = ''; }

  function init(root) {
    root = root || document;
    document.body.classList.add('vl-page');

    /* global chrome (bind once) */
    if (!window.__vlChrome) {
      window.__vlChrome = true;
      document.addEventListener('click', function (e) {
        var add = e.target.closest('[data-vl-add]');
        if (add) { e.preventDefault(); addToCart(add.getAttribute('data-vl-add'), parseInt(add.getAttribute('data-vl-qty') || '1', 10));
          if (add.classList.contains('vl-add')) { add.classList.add('vl-done'); setTimeout(function () { add.classList.remove('vl-done'); }, 700); } return; }
        var inc = e.target.closest('[data-vl-inc]'); if (inc) { changeCart(inc.getAttribute('data-vl-inc'), qtyOf(inc, 1)); return; }
        var dec = e.target.closest('[data-vl-dec]'); if (dec) { changeCart(dec.getAttribute('data-vl-dec'), qtyOf(dec, -1)); return; }
        var rem = e.target.closest('[data-vl-rem]'); if (rem) { changeCart(rem.getAttribute('data-vl-rem'), 0); return; }
        if (e.target.closest('#vlCartBtn')) { e.preventDefault(); refreshCart(true); return; }
        if (e.target.closest('#vlDrawerClose') || e.target.closest('#vlOverlay')) { closeCart(); return; }
        if (e.target.closest('#vlBurger')) { var m = document.getElementById('vlMnav'); if (m) { m.classList.add('vl-on'); document.body.style.overflow = 'hidden'; } return; }
        if (e.target.closest('#vlMnavClose')) { var m2 = document.getElementById('vlMnav'); if (m2) { m2.classList.remove('vl-on'); document.body.style.overflow = ''; } return; }
      });
      function qtyOf(btn, delta) {
        var span = btn.parentElement.querySelector('span');
        return Math.max(0, (parseInt(span.textContent, 10) || 1) + delta);
      }
      window.addEventListener('scroll', function () { var h = document.getElementById('vlHeader'); if (h) h.classList.toggle('vl-shrunk', window.scrollY > 40); }, { passive: true });
      refreshCart(false);
    }

    /* FAQ accordion */
    root.querySelectorAll('.vl-faq-q').forEach(function (q) {
      if (q.dataset.vlB) return; q.dataset.vlB = '1';
      q.addEventListener('click', function () {
        var item = q.parentElement, a = q.nextElementSibling, open = item.classList.contains('vl-open'), list = item.parentElement;
        list.querySelectorAll('.vl-faq-item').forEach(function (it) { it.classList.remove('vl-open'); var aa = it.querySelector('.vl-faq-a'); if (aa) aa.style.maxHeight = null; });
        if (!open && a) { item.classList.add('vl-open'); a.style.maxHeight = a.scrollHeight + 'px'; }
      });
    });

    /* reveal */
    var rev = root.querySelectorAll('.vl-reveal:not(.vl-in)');
    if (rev.length) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('vl-in'); io.unobserve(en.target); } }); }, { threshold: .12 });
        rev.forEach(function (el) { io.observe(el); });
      } else rev.forEach(function (el) { el.classList.add('vl-in'); });
    }

    /* countdown(s) */
    root.querySelectorAll('[data-vl-countdown]').forEach(function (box) {
      if (box.dataset.vlB) return; box.dataset.vlB = '1';
      var H = box.querySelector('[data-h]'), M = box.querySelector('[data-m]'), Sx = box.querySelector('[data-s]');
      var end = new Date(); end.setHours(23, 59, 59, 999);
      function tk() { var d = end - new Date(); if (d < 0) { end.setDate(end.getDate() + 1); d = end - new Date(); }
        var h = Math.floor(d / 3.6e6), m = Math.floor(d % 3.6e6 / 6e4), s = Math.floor(d % 6e4 / 1e3);
        if (H) H.textContent = ('0' + h).slice(-2); if (M) M.textContent = ('0' + m).slice(-2); if (Sx) Sx.textContent = ('0' + s).slice(-2);
        if (box.hasAttribute('data-single')) box.textContent = ('0' + h).slice(-2) + ':' + ('0' + m).slice(-2) + ':' + ('0' + s).slice(-2);
      }
      tk(); setInterval(tk, 1000);
    });

    /* collection sort auto-submit */
    root.querySelectorAll('[data-vl-sort]').forEach(function (sel) {
      if (sel.dataset.vlB) return; sel.dataset.vlB = '1';
      sel.addEventListener('change', function () { if (sel.form) sel.form.submit(); });
    });
    /* price range label (visual) */
    root.querySelectorAll('#vlRange').forEach(function (rg) {
      if (rg.dataset.vlB) return; rg.dataset.vlB = '1';
      var rv = root.querySelector('#vlRangeVal');
      rg.addEventListener('input', function () { if (rv) rv.textContent = rg.value + '€'; });
    });
    /* mobile filter drawer */
    var fo = root.querySelector('#vlFOpen'), fc = root.querySelector('#vlFClose'), ff = root.querySelector('#vlFilters'), fb = root.querySelector('#vlFBg');
    if (fo && ff && !fo.dataset.vlB) { fo.dataset.vlB = '1';
      var openF = function () { ff.classList.add('vl-on'); if (fb) fb.classList.add('vl-on'); document.body.style.overflow = 'hidden'; };
      var closeF = function () { ff.classList.remove('vl-on'); if (fb) fb.classList.remove('vl-on'); document.body.style.overflow = ''; };
      fo.addEventListener('click', openF); if (fc) fc.addEventListener('click', closeF); if (fb) fb.addEventListener('click', closeF);
    }

    /* PDP */
    var pdp = root.querySelector('[data-vl-pdp]');
    if (pdp && !pdp.dataset.vlB) { pdp.dataset.vlB = '1'; initPdp(pdp); }
  }

  function initPdp(pdp) {
    var variants = []; try { variants = JSON.parse(pdp.querySelector('#vl-variants').textContent); } catch (e) {}
    var idInput = pdp.querySelector('input[name="id"]');
    var priceNow = pdp.querySelector('[data-vl-price]'), priceWas = pdp.querySelector('[data-vl-was]'), saveEl = pdp.querySelector('[data-vl-save]');
    var vName = pdp.querySelector('#vlVarName');
    var addBig = pdp.querySelector('#vlAddBig');
    var mainImg = pdp.querySelector('#vlGImg');
    var selected = {};
    var first = variants.find(function (v) { return v.available; }) || variants[0];
    if (first) { selected[0] = first.option1; selected[1] = first.option2; selected[2] = first.option3; }
    function cur() { return variants.find(function (v) { return v.option1 == selected[0] && (v.option2 == null || v.option2 == selected[1]) && (v.option3 == null || v.option3 == selected[2]); }); }
    function upd() {
      pdp.querySelectorAll('[data-vl-opt]').forEach(function (b) { b.classList.toggle('vl-sel', String(selected[+b.dataset.vlOpt]) === b.dataset.vlVal); });
      var v = cur(); if (!v) return;
      if (idInput) idInput.value = v.id;
      if (addBig) addBig.setAttribute('data-vl-add', v.id);
      if (priceNow) priceNow.textContent = money(v.price);
      if (priceWas) { var on = v.compare_at_price > v.price; priceWas.style.display = on ? '' : 'none'; if (on) priceWas.textContent = money(v.compare_at_price); if (saveEl) { saveEl.style.display = on ? '' : 'none'; if (on) saveEl.textContent = '–' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; } }
      if (vName) vName.textContent = v.title;
      if (mainImg && v.featured_image && v.featured_image.src && mainImg.tagName === 'IMG') mainImg.src = v.featured_image.src;
    }
    pdp.querySelectorAll('[data-vl-opt]').forEach(function (b) { b.addEventListener('click', function () { selected[+b.dataset.vlOpt] = b.dataset.vlVal; upd(); }); });
    var q = 1, qEl = pdp.querySelector('#vlQty');
    var qp = pdp.querySelector('#vlQtyPlus'), qm = pdp.querySelector('#vlQtyMinus');
    if (qp) qp.addEventListener('click', function () { q++; qEl.textContent = q; if (addBig) addBig.setAttribute('data-vl-qty', q); });
    if (qm) qm.addEventListener('click', function () { if (q > 1) { q--; qEl.textContent = q; if (addBig) addBig.setAttribute('data-vl-qty', q); } });
    /* gallery thumbs */
    var thumbs = pdp.querySelectorAll('[data-vl-thumb]');
    thumbs.forEach(function (t) { t.addEventListener('click', function () { thumbs.forEach(function (x) { x.classList.remove('vl-active'); }); t.classList.add('vl-active'); if (mainImg && mainImg.tagName === 'IMG') mainImg.src = t.getAttribute('data-vl-thumb'); }); });
    upd();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  /* ---------- Sticky-Kaufleiste (PDP-Story-Seiten) ---------- */
  function vlStickyBar() {
    var bar = document.querySelector('[data-vl-sticky]');
    if (!bar) return;
    var anchor = document.querySelector('.vl-buy-actions') || document.querySelector('[data-vl-add]');
    if (!anchor) return;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('vl-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vlStickyBar);
  } else { vlStickyBar(); }
  document.addEventListener('shopify:section:load', vlStickyBar);

})();
